
import React from 'react'
import Select from 'react-select'

interface Option {
    label: string,
    value: string | number
}

interface CustomMultiSelectProps {
    values: Array<string | number>,
    options: Option[],
    onChange: (selectedValues: Array<string | number>) => void,
    placeholder: string,
    disabled?: boolean,
    [key: string]: any,
}

const CustomMultiSelect = (props: CustomMultiSelectProps) => {


    const getLabel = (value: string | number) => {
        for (let option of props.options) {
            if (option.value === value) return option.label;
        }
        return "-";
    }

    return (
        <React.Fragment>
            {
                !props.disabled &&
                <Select
                    {...props}
                    placeholder={props.placeholder}
                    isMulti
                    styles={{
                        multiValueLabel: (base: any) => {
                            return { ...base, color: "white" }
                        }
                    }}
                    options={props.options.filter((opt) => !props.values.includes(opt.value))}
                    classNamePrefix={'influns'}
                    value={null}
                    onChange={(selectedValues) => {
                        let selected_values = [...props.values];

                        if (Array.isArray(selectedValues)) {
                            for (let selected of selectedValues) {
                                selected_values.push(selected.value);
                            }
                        }
                        props.onChange(selected_values)
                    }}
                />
            }
            {
                props.values.length > 0 &&
                <div className="selected-multi-values mt-2">
                    {props.values.map((val, i) => (
                        <span key={i} className="selected-value-badge">
                            {getLabel(val)}
                            {
                                !props.disabled &&
                                <span className='cursor-pointer' onClick={() => {
                                    let selected_options = props.values.filter((selectedVal) => selectedVal !== val);
                                    props.onChange(selected_options);
                                }}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5.80549" cy="5.80549" r="4.80549" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.3125 7.3125L4.3125 4.3125" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.3125 7.3125L7.3125 4.3125" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            }
                        </span>
                    ))}
                </div>
            }
        </React.Fragment>
    )
}

export default CustomMultiSelect